import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "@/helpers/Store/store";
import Antd from "ant-design-vue";
import CountryFlag from "vue-country-flag-next";
import VueFeather from "vue-feather";
import VOtpInput from "vue3-otp-input";
import VueTelInput from "vue-tel-input";
import VueSignature from "vue-signature-pad";
import CKEditor from "@ckeditor/ckeditor5-vue";
import VueGoogleMaps from "@fawmi/vue-google-maps";
import VueApexCharts from "vue3-apexcharts";
import VLazyImage from "v-lazy-image";
import StarRating from "vue-star-rating";
import VueDraggableResizable from "vue-draggable-resizable";

import ModalPlugin from "@/helpers/Navigation.js";

import "vue-tel-input/vue-tel-input.css";
import "ant-design-vue/dist/antd.css";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap";
import "@/assets/sass/style.css";
import "@/assets/sass/media.css";

const app = createApp(App);
app.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyCdNPEZUlqr2gjnXXotK-XlAkNzhg0DHpA",
  },
});

app.component(VueFeather.name, VueFeather);
app.component("country-flag", CountryFlag);
app.component("v-otp-input", VOtpInput);
app.component("VLazy", VLazyImage);
app.component("VDrag", VueDraggableResizable);
app.component("Star", StarRating);
app.use(VueApexCharts);
app.use(VueTelInput);
app.use(VueSignature);
app.use(ModalPlugin);
app.use(CKEditor);
app.use(Antd);
app.use(router);
app.use(store);
app.mount("#app");
